import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';
import { metaScreen } from '../lib/metaPixel';

// One page view per screen the router shows (#458), reported as the route's
// pattern — `/students/:id`, never the student's id — by
// src/lib/analyticsEvents.js `pageViewPath`. Keyed on the pathname alone, so a
// query string or a hash changing on the same screen is not a second view.
// While denied `trackPageView` only remembers where the visitor is, so that
// allowing on this screen counts it once (src/lib/analytics.js).
//
// The Meta Pixel (#780) hears every change, the query and the fragment too:
// it sends the real address, so it counts a screen's view only once the
// address carries nothing personal (src/lib/metaPixel.js `addressIsClean`),
// and still once per pathname.
export function usePageViews() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);
  useEffect(() => {
    metaScreen(pathname, search, hash);
  }, [pathname, search, hash]);
}
